// Create SEO-friendly URL slug from German text
export const createSlug = (text) => {
  if (!text) return '';
  
  return text
    .toLowerCase()
    // Replace German umlauts
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/ß/g, 'ss')
    // Remove special characters except letters, numbers, spaces, and hyphens
    .replace(/[^a-z0-9\s-]/g, '')
    // Replace multiple spaces or hyphens with single hyphen
    .replace(/[\s-]+/g, '-')
    // Remove leading/trailing hyphens
    .replace(/^-+|-+$/g, '')
    // Limit length
    .substring(0, 50)
    .replace(/-+$/, ''); // Remove trailing hyphens after truncation
};

// Extract post ID from slug (assuming format: title-slug-postid)
export const extractIdFromSlug = (slug) => {
  if (!slug) return null;
  
  // Try to find ID at the end of slug
  const parts = slug.split('-');
  const lastPart = parts[parts.length - 1];
  
  // Check if last part looks like a MongoDB ObjectId (24 hex chars)
  if (lastPart.length === 24 && /^[0-9a-fA-F]+$/.test(lastPart)) {
    return lastPart;
  }
  
  // Fallback: use the whole slug as ID
  return slug;
};